import PropTypes from 'prop-types';

export const Props = {
  /**
   * Icon name
   */
  icon: PropTypes.string,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
